import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import axios from "axios";
import {toFarsiNumber} from "../../cudtom-hooks/en-to-persian";
import {callApiAgain, setPasswordFormServerError, showPopUp, updatePending} from "../common-states/commonStatesSlice";

const config = {
    headers: {Authorization: `Token ${localStorage.getItem('token')}`}
}
export const getUsers = createAsyncThunk("user/getUsers", async(dispatch) => {
    let bodyArray = []
    dispatch(updatePending(true))
    await axios.get('https://demo.khedmatashayer-kj.ir/api/v1/user', config)
        .then((response) => {
            response.data.forEach(item => {
                bodyArray = [...bodyArray, [<i className="fa fa-trash delete" onClick={() => dispatch(deleteUser({userId: item.user_id, dispatch}))}></i>,
                    <i className="fa fa-key key" onClick={() => dispatch(setUserInfo({obj: item, type: 'showPasswordForm'}))}></i>,
                    <i className="fa fa-edit edit" onClick={() => dispatch(setUserInfo({obj: item, type: 'showEditForm'}))}></i>
                    , item.location_permissions ? <select className='table-city-select' value={item.location_permissions[0].cities[0].city} readOnly>{item.location_permissions[0].cities.map((item1, index) => <option key={index} disabled>{item1.city}</option>)}</select>
                        : <span>همه شهرها</span>, toFarsiNumber(item.mobile), item.username, item.name]]
            })
            dispatch(updatePending(false))
        })
        .catch(() => {
            alert('خطا در برقراری ارتباط با سرور')
        })
    return bodyArray
})

export const deleteUser = createAsyncThunk("user/deleteUser", async(data) => {
    const {userId, dispatch} = data
    let r = window.confirm("آیا برای حذف این مشترک اطمینان دارید؟");
    if(r === true){
        axios.delete(`https://demo.khedmatashayer-kj.ir/api/v1/user/${userId}`, config)
            .then((res) => {
                console.log(res.data)
                dispatch(callApiAgain(true))
                alert('کاربر موردنظر با موفقیت حذف شد!')
            })
            .catch(() => {
                alert('خطا در برقراری ارتباط با سرور')
            })
    }
})

export const postUserPasswordForm = createAsyncThunk("user/postUserPasswordForm", async(allData) => {
    const {data, dispatch} = allData
    axios.post('https://demo.khedmatashayer-kj.ir/api/v1/user/password/forget', data, config)
        .then((res) => {
            alert(res.data.message)
            dispatch(setPasswordFormServerError(''))
        })
        .catch((err) => {
            alert('با خطا مواجه شد!')
            dispatch(setPasswordFormServerError(err.response.data.message))
        })
})

export const addOrEditUser = createAsyncThunk("user/addOrEditUser", async(allData) => {
    const {data, registerBtnType, userId, password, dispatch} = allData
    if(registerBtnType === 'ثبت'){
        await axios.post('https://demo.khedmatashayer-kj.ir/api/v1/user', {
            ...data,
            created_at: new Date().toISOString(),
            password: password,
        }, config)
            .then((res) => {
                dispatch(callApiAgain(true))
                dispatch(showPopUp({type: 'showForm', value: false})) //This comes from UserSectionMenu
                alert(res.data.message)
            })
            .catch((err) => {
                dispatch(setUserServerError(err.response.data.message))
            })
    }
    else if(registerBtnType === 'ویرایش'){
        await axios.put(`https://demo.khedmatashayer-kj.ir/api/v1/user/${userId}`, data, config)
            .then(res => {
                dispatch(callApiAgain(true))
                dispatch(showPopUp({type: 'showEditForm', value: false})) //This comes from UserManagement
                alert(res.data.message)
            })
            .catch(err => {
                alert('خطا در برقراری ارتباط با سرور')
            })
    }
})

const userSlice = createSlice({
    name: 'user',
    initialState: {
        bodyArray: [],
        selectedUser: {obj: null, type: ''},
        serverError: '',
        showUserPasswordForm: false
    },
    reducers: {
        setUserInfo: (state, action) => {
            state.selectedUser = action.payload
        },
        setUserServerError: (satate, action) => {
            satate.serverError = action.payload
        },
        handleShowUserPasswordForm: (state, action) => {
            state.showUserPasswordForm = action.payload
        }
    },
    extraReducers(builder){
        builder
            .addCase(getUsers.fulfilled, (state, action) => {
                state.bodyArray = action.payload
            })
    }
})

export const {setUserInfo, setUserServerError, handleShowUserPasswordForm} = userSlice.actions
export const selectUsersBodyArray = state => state.user.bodyArray
export const selectSelectedUser = state => state.user.selectedUser
export const selectUserServerError = state => state.user.serverError
export const selectShowUserPasswordForm = state => state.user.showUserPasswordForm

export default userSlice.reducer